/* ================================================== */
/* ISOTOPE → set posters heights
/* ================================================== */

function setPostersHeights() {
	var $posters     = $('#works article .poster'),
		totalPosters = $posters.length;

	$posters.each(function(index, element) {
		var width     = $(element).attr('width'),
			height    = $(element).attr('height'),
			realWidth = $(element).width();
		$(element).height((realWidth*height)/width);

		if (!--totalPosters) {
			setTimeout(function(){
				$('#works .work-item').addClass('initialized')
			}, 1000);
		}
	});

	grid.isotope();
}

$(document).ready(setPostersHeights());
$(window).on('resize orientationchange', function() {
	setPostersHeights();
});
